<template>
    <v-row dense>
        <v-col cols="12" md="12">
            <v-card variant="outlined">
                <v-card-title>
                    <span class="font-weight-bold text-subtitle-2">
                        {{ $t('restrictions_on_tourists') }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12">
                            <div class="mb-2 ms-2">{{ $t('discount_terms.discount_applied') }}</div>
                            <v-radio-group v-model="discountConditions.groupNature">
                                <v-radio :label="$t('discount_terms.for_all_tourists')" value="FOR_ALL" />
                                <v-radio value="FOR_GROUPS">
                                    <template v-slot:label>
                                        <div class="d-inline-flex flex-wrap text--primary align-center">
                                            <div class="me-2">
                                                {{ $t('discount_terms.for_groups_from') }}
                                            </div>
                                            <v-number-input
                                                v-model="discountConditions.countOfTourists"
                                                :max="120"
                                                :min="0"
                                                hide-details
                                                :density="'compact'"
                                                class="me-2"
                                                :disabled="discountConditions.groupNature !== 'FOR_GROUPS'"
                                                :step="1"
                                            />
                                            <div>
                                                {{ $t('discount_terms.passengers') }}
                                            </div>
                                        </div>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
    const discountConditions = defineModel<any>()
</script>
